// extracted by mini-css-extract-plugin
export default {"card":"Card_card__4ar6Y","inner":"Card_inner__7Ub7I","img":"Card_img__LlFdp","content":"Card_content__EKQWs","stack":"Card_stack__DBLQc","footer":"Card_footer__oecvH"};